import { useState } from "react";
import { Modal, Form, Input, message, Checkbox, Alert } from "antd";
import axios from "axios";
import { useAuth0 } from "../../react-auth0-spa";
import { useAppContext } from "../../context";
import config from "../../api_config.json";
import createCategoryMutation from "./queries/createCategoryMutation";

const CreateCategoryModal = ({ visible, onCancel, onCreate }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const { getTokenSilently } = useAuth0();
  const { isProd } = useAppContext();
  const env = isProd ? "prod" : "dev";

  const handleCreate = async () => {
    try {
      const values = await form.validateFields();

      // Validate at least one of b2b or b2c is selected
      if (!values.b2b && !values.b2c) {
        message.error("Seleziona almeno una modalità (B2B o B2C)");
        return;
      }

      setLoading(true);

      const token = await getTokenSilently();
      const graphqlUrl = `${config.baseUrl[env]}/graphql?raw=true`;

      const fields = {
        name: values.name,
        b2b: values.b2b || false,
        b2c: values.b2c || false,
        ACL: {
          public: {
            read: true,
            write: false
          }
        }
      };

      await axios.post(
        graphqlUrl,
        {
          query: createCategoryMutation,
          variables: { fields },
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      message.success("Categoria creata con successo");
      form.resetFields();
      onCreate();
    } catch (error) {
      if (error.errorFields) {
        // Validation error from form
        return;
      }
      console.error("Error creating category:", error);
      message.error("Errore durante la creazione della categoria");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      title="Crea Nuova Categoria"
      open={visible}
      onOk={handleCreate}
      onCancel={handleCancel}
      okText="Crea"
      cancelText="Annulla"
      confirmLoading={loading}
      width={500}
      maskClosable={false}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={{
          b2b: false,
          b2c: false,
        }}
      >
        <Form.Item
          label="Nome"
          name="name"
          rules={[{ required: true, message: "Il nome è obbligatorio" }]}
        >
          <Input placeholder="Nome della categoria" />
        </Form.Item>

        <Form.Item label="Modalità" required>
          <Alert
            message="Seleziona almeno una modalità"
            description="La categoria deve essere disponibile per almeno una modalità di vendita"
            type="info"
            showIcon
            style={{ marginBottom: 12 }}
          />
          <Form.Item name="b2b" valuePropName="checked" noStyle>
            <Checkbox>B2B (Fornitore per agenzie)</Checkbox>
          </Form.Item>
          <br />
          <Form.Item name="b2c" valuePropName="checked" noStyle>
            <Checkbox>B2C (Vendita diretta al cliente)</Checkbox>
          </Form.Item>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CreateCategoryModal;
